import { add } from 'date-fns';

/** Maximum days in the future or in the past an appointment can be rescheduled */
export const MAX_RESCHEDULE_DAYS_RANGE = 14;

export const getMaxRescheduleDate = (appointmentDate: Date): Date => {
  return add(appointmentDate, { days: MAX_RESCHEDULE_DAYS_RANGE });
};
